define('helpers',['require','helperComponent-getContent','helperComponent-getContentArray','helperComponent-parseContent','helperComponent-parseProp','helperContent','helperEntity','helperLayout','helperLearning','helperMisc','helperNavigation','helperURL-getParam','helperURL-parseModified','helperUser'],function(require) {
    'use strict';

    var Helpers = {
        component: {
            getContent: require('helperComponent-getContent'),
            getContentArray: require('helperComponent-getContentArray'),
            parseContent: require('helperComponent-parseContent'),
            parseProp: require('helperComponent-parseProp')
        },
        content: require('helperContent'),
        entity: require('helperEntity'),
        layout: require('helperLayout'),
        learning: require('helperLearning'),
        misc: require('helperMisc'),
        navigation: require('helperNavigation'),
        URL: {
            getParam: require('helperURL-getParam'),
            parseModified: require('helperURL-parseModified')
        },
        User: require('helperUser')
    };

    return Helpers;
});

